import React from "react";
import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import palette from "src/theme/palette";
import EmptyBox from "src/static/images/empty_box.svg";

const Container = styled(Stack)({
  backgroundColor: palette.system[0],
  border: "1px solid",
  borderColor: palette.system[200],
  borderRadius: 8,
  justifyContent: "center",
  alignItems: "center",
  minHeight: 400
});

const SubscriptionErrorState = () => (
  <Container data-testid="subscription-error-state">
    <Stack alignItems="center" gap={1}>
      <img src={EmptyBox} alt="" />
      <Typography variant="body1" color="text.700" sx={{ mt: 2 }}>
        Failed to load subscription data.
      </Typography>
      <Typography variant="body2" color="text.600">
        Please try again later or contact support if the issue persists.
      </Typography>
    </Stack>
  </Container>
);

export default SubscriptionErrorState;
